import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../api/afiliasiAPI";

export default {
  registerStatus: ({ commit }) => {
    conn
      .get(api.registerStatus)
      .then((res) => {
        if (res.data.code === 200) {
          localStorage.isAfiliator = res.data.data.statusAfiliasi;

          if (res.data.data.statusAfiliasi) {
            commit("setResponse", resulter.successResult(res.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  registerAfiliator: (state) => {
    let { commit } = state;
    let { register } = api;
    commit("setFetching", true);
    conn
      .post(register, null, conn.contentType.form)
      .then((response) => {
        if (response.data.status) {
          commit("setResponse", resulter.successResult(response.data.msg));
        } else {
          commit("setResponse", resulter.errorResult(response.data.msg));
        }
        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getAfiliasi: (state, payload) => {
    let { commit, dispatch } = state;
    conn
      .get(api.afiliasi)
      .then((response) => {
        if (response.data.code === 200) {
          if (payload === "loadAll") {
            dispatch("getLastWithdraw");
          }
          commit("setDataAfiliasi", response.data.data);
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getLastWithdraw: ({ commit, dispatch }) => {
    commit("setLastWithdraw", []);
    conn
      .get(api.lastWithdraw)
      .then((response) => {
        if (response.data.code === 200) {
          dispatch("getDataRekening", "afiliated");
          if (response.data.data) {
            commit("setLastWithdraw", [response.data.data]);
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getDataRekening: ({ commit, dispatch }, payload) => {
    commit("setDataRekening", { namaBank: "", noRekening: "", pemilik: "" });
    conn
      .get(api.dataRekening)
      .then((response) => {
        if (response.data.code === 200) {
          if (payload === "afiliated") {
            dispatch("getDataAfiliated");
          }
          if (response.data.data) {
            commit("setDataRekening", response.data.data);
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getDataAfiliated: ({ commit, dispatch }) => {
    commit("setDataAfiliated", { totalTeman: "", totalOutlet: "" });
    commit("setResponse", {});
    conn
      .get(api.dataAfiliated)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataAfiliated", response.data.data);
            dispatch("getTotalWithdraw");
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getTotalWithdraw: ({ commit, dispatch }) => {
    conn
      .get(api.totalWithdraw)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setResponse", resulter.successResult(response.data.msg));
            commit("setTotalWithdraw", response.data.data);
            dispatch("getListBank");
          }
        }
      })
  },
  getMutasiSaldo: ({ commit, getters }) => {
    let query = {
      limit: getters.pagination.limit,
      offset: getters.pagination.offset,
    };

    commit("setFetching", true);
    if (getters.mutasiSaldo.length > 0) {
      commit("setLoadMore", true);
    }
    conn
      .get(api.mutasiSaldo, query)
      .then((response) => {
        if (response.data.code === 200) {
          conn.setQueryString(query);
          commit("updateMutasiSaldo", response.data);
          commit("setNextPagination", { data: response.data.data, type: "mutasiSaldo" });
          if (response.data.status) {
            commit("setResponse", resulter.successResult(response.data.msg));
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("helper/setScrollCalled", false, { root: true });
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getWithdrawHistory: ({ commit, getters }) => {
    let query = {
      limit: getters.pagination.limit,
      offset: getters.pagination.offset,
    };

    commit("setFetching", true);
    if (getters.withdrawHistory.length > 0) {
      commit("setLoadMore", true);
    }
    conn
      .get(api.withdrawHistory, query)
      .then((response) => {
        if (response.data.code === 200) {
          conn.setQueryString(query);
          commit("updateWithdrawHistory", response.data);
          commit("setWithdrawHistoryTotal", response.data);
          commit("setNextPagination", { data: response.data.data, type: "withdrawHistory" });
          if (response.data.status) {
            commit("setResponse", resulter.successResult(response.data.msg));
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("helper/setScrollCalled", false, { root: true });
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getListAfiliated: ({ commit, getters, rootGetters }, payload) => {
    let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

    let query = {
      limit: getters.pagination.limit,
      offset: getters.pagination.offset,
      key: payload,
      filter_aktif: getFilterItem.afiliasiOwner === "0" ? "" : getFilterItem.afiliasiOwner,
    };

    commit("setFetching", true);
    if (getters.afiliated.length > 0) {
      commit("setLoadMore", true);
    }
    conn
      .get(api.listAfiliated, query)
      .then((response) => {
        if (response.data.code === 200) {
          conn.setQueryString(query);
          if (response.data.data) {
            commit("updateAfiliated", response.data);
            commit("setAfiliatedTotal", response.data);
            commit("setNextPagination", { data: response.data.data, type: "afiliated" });
          }

          if (response.data.status) {
            commit("setResponse", resulter.successResult(response.data.msg));
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("helper/setScrollCalled", false, { root: true });
      })
      .catch((e) => {
        console.log(e)
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getListBank: ({ commit }) => {
    commit("setFetching", true);
    conn
      .get(api.listBank)
      .then((response) => {
        if (response.data.code === 200) {
          commit("setListBank", response.data.data);

          if (!response.data.status) {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }

        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  updateBank: ({ commit }, data) => {
    let posted = new FormData();

    Object.keys(data).forEach(function(key) {
      posted.append(key, data[key]);
    });

    commit("setFetching", true);
    conn
      .post(api.setBank, posted, conn.contentType.form)
      .then((response) => {
        if (response.data.status) {
          commit("setResponse", resulter.successResult(response.data.msg));
        } else {
          commit("setResponse", resulter.errorResult(response.data.msg));
        }
        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  doWithdraw: ({ commit }, { amount, otp }) => {
    let posted = new FormData();
    posted.append("amount", amount);
    posted.append("otp", otp)

    commit("setFetching", true);
    conn
      .post(api.withdraw, posted, conn.contentType.form)
      .then((response) => {
        if (response.data.status) {
          commit("setResponse", resulter.successResult(response.data.msg));
        } else {
          commit("setResponse", resulter.errorResult(response.data.msg));
        }
        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getdetailOwner: ({ commit }) => {
    conn
      .get(api.detailOwner)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailOwner", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  sendOTP: ({ commit }, phoneNumber) => {
    let posted = new FormData();
    posted.append("telp", phoneNumber);

    commit("setFetching", true);
    conn
      .post(api.sendOtp, posted, conn.contentType.form)
      .then((response) => {
        if (response.data) {
          if (response.data.status) {
            commit("setResponse", resulter.successResult(response.data.msg));
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        } else {
          commit("setResponse", resulter.errorResult(response));
        }
        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  }
};
